import { modifier } from "../modifiers";

modifier("upcase", (value) => value.toString().toUpperCase());
